var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMp4 = function SvgMp4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.5 10.5 18 6h4.5zM4.5 13h13.6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 9,
    x: 2.1,
    y: 11,
    fill: "#1C7ABE",
    rx: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.622 13.5h1.043l1.102 2.688h.046L7.915 13.5h1.043v4h-.82v-2.604h-.034L7.07 17.48h-.558l-1.035-2.593h-.034V17.5h-.82zm5.198 4v-4h1.578q.455 0 .775.174.321.172.489.478.17.306.17.704t-.173.703q-.171.304-.498.474-.323.17-.785.17h-1.005v-.678h.869a.85.85 0 0 0 .402-.084.56.56 0 0 0 .238-.236.74.74 0 0 0 .08-.35.7.7 0 0 0-.08-.347.54.54 0 0 0-.238-.233.9.9 0 0 0-.406-.084h-.57V17.5zm3.642-.703v-.666l1.67-2.631h.574v.922h-.34l-1.053 1.666v.031h2.373v.678zm1.92.703v-.906l.015-.295V13.5h.793v4z"
  })));
};
export default SvgMp4;